document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector('store-header.header');
    header.addEventListener('mouseenter', () => {
      const elementsWithClass = document.querySelectorAll('.tmenu_item_submenu_type_mega.tmenu_item_has_child');
      elementsWithClass.forEach(element => {
        element.addEventListener('mouseover', () => {
          header.classList.add('is-filled');
        });
      });
    });
});
  
// remove comparable btn in slider
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function() {
    document.querySelectorAll('#slideshow-template--18899371917591__slideshow .comparable-btn').forEach(el => {
        el.style.display = 'none';
    })
  }, 500);
});



// ===================================================================================================================
// ===================================================================================================================
// ============================================= Smooth scroll ==============================================
// ===================================================================================================================
// ===================================================================================================================

// count offset from element to top (including parents)
function getOffsetTop(element) {
    if (!element) return 0;
    return getOffsetTop(element.offsetParent) + element.offsetTop;
};

// needed to create custom scroll cause 
// default scroll was freezing in half way
function scrollToSmoothly(pos, time) {
    var currentPos = window.scrollY;
    var start = null;
    if(time == null) time = 500;
    pos = +pos, time = +time;
    window.requestAnimationFrame(function step(currentTime) {
        start = !start ? currentTime : start;
        var progress = currentTime - start;
        if (currentPos < pos) {
            window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
        } else {
            window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
        }
        if (progress < time) {
            window.requestAnimationFrame(step);
        } else {
            window.scrollTo(0, pos);
        }
    });
};

// need to calculate height of header to properly scroll withut cut section header
function getHeaderHeight() {
    return document.getElementById('shopify-section-sections--18899372343575__announcement-bar').offsetHeight + document.getElementById('shopify-section-sections--18899372343575__header').offsetHeight;
}

  
// ===================================================================================================================
// ===================================================================================================================
// ============================================= Blog table of contents ==============================================
// ===================================================================================================================
// ===================================================================================================================



function prepareTextAsDataId(text) {
    text = text.toLowerCase().trim().replaceAll(new RegExp(/\s+/, 'g'), '-');
    return replacePolishCharacters(text);
}

function replacePolishCharacters(text) {
    text = text.toLowerCase();
    text = text.replaceAll('ą', 'a');
    text = text.replaceAll('ś', 's');
    text = text.replaceAll('ę', 'e');
    text = text.replaceAll('ó', 'o');
    text = text.replaceAll('ł', 'l');
    text = text.replaceAll('ż', 'z');
    text = text.replaceAll('ź', 'z');
    text = text.replaceAll('ć', 'c');
    text = text.replaceAll('ń', 'n');
    return text;
}

function createTableOfContents(headersList) {
    const box = document.createElement('div');
    const ol = document.createElement('ol');
    box.setAttribute('id', 'custom-table-of-contents');
    for (let i = 0; i < headersList.length; i++) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', '#' + headersList[i].id);
        a.innerText = headersList[i].text;
        li.appendChild(a);
        ol.appendChild(li);
    }

    const title = document.createElement('p');
    title.innerHTML = 'Spis Treści';
    box.appendChild(title);
    box.appendChild(ol);
    return box;
}

// scroll to section when loading page with hash
function scrollToHash() {
    if (window.location.hash != '') {
        scrollToSmoothly(getOffsetTop(document.querySelector('div.prose [data-id="' + window.location.hash + '"]')) - getHeaderHeight(), 1000);
    }
}
  
document.addEventListener("DOMContentLoaded", () => {
    let articleContent = document.querySelector('.article-content .prose');

    if (articleContent != null) {
        let tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    
        let childrenList = articleContent.children;
        let headersList = [];
        
        for (let i = 0; i < childrenList.length; i++) {
            const element = childrenList[i];
            if (tags.includes(element.tagName.toLowerCase())) {
                let text = element.innerText;
                text = prepareTextAsDataId(text);
                console.log(text);
                element.setAttribute('data-id', '#' + text);
                headersList.push({
                    'id': text,
                    'text': element.innerText
                });
            } else continue;
        }
        articleContent.insertBefore(createTableOfContents(headersList), articleContent.firstChild);

        // scroll
        document.querySelectorAll('#custom-table-of-contents > ol > li > a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                console.log('click');
                e.preventDefault();
                window.location.hash = this.getAttribute('href');
                console.log(document.querySelector('div.prose > [data-id="' + this.getAttribute('href') + '"]'));
                console.log(getOffsetTop(document.querySelector('div.prose > [data-id="' + this.getAttribute('href') + '"]')));
                scrollToSmoothly(getOffsetTop(document.querySelector('div.prose > [data-id="' + this.getAttribute('href') + '"]')) - getHeaderHeight(), 1000);
            });
        });

        scrollToHash();
    }
});

// replace sku in h1 on product page
if (ShopifyAnalytics.meta.page.pageType == 'product') {
    document.addEventListener('variant:change', function(event) {
      let variant = event.detail.variant; // Gives you access to the whole variant details
      let previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
      let product = event.detail.product; // Gives you access to the whole product that the variant belongs to
      let form = event.target; // The form that triggers the change

      document.querySelector('#custom-h1-sku').innerHTML = variant.sku;
  });
}

// show hide text on front page
// if (ShopifyAnalytics.meta.page.pageType == 'home') {
//   let firstP = document.querySelector('section#shopify-section-template--18899371917591__rich_text_wEaPVb div.prose div:nth-child(2)');
//   let showMore = document.createElement('a');
//   showMore.class = "show-more";
//   showMore.setAttribute('href', '#');
//   showMore.setAttribute('data-show', 'more');
//   showMore.text = "Pokaż więcej";
//   firstP.after(showMore);
//   showMore.addEventListener('click', function(e) {
//     e.preventDefault();
//     if (this.getAttribute('data-show') == 'more') {
//       this.setAttribute('data-show', 'less');
//       this.text = "Pokaż mniej";
//       document.querySelector('section#shopify-section-template--18899371917591__rich_text_wEaPVb div.prose div:nth-child(2)').style.overflow = 'unset';
//       document.querySelector('section#shopify-section-template--18899371917591__rich_text_wEaPVb div.prose div:nth-child(2)').style.height = 'auto';
//     } else {
//       this.text = "Pokaż więcej";
//       this.setAttribute('data-show', 'more');
//       document.querySelector('section#shopify-section-template--18899371917591__rich_text_wEaPVb div.prose div:nth-child(2)').style.overflow = 'hidden';
//       document.querySelector('section#shopify-section-template--18899371917591__rich_text_wEaPVb div.prose div:nth-child(2)').style.height = '60px';
//     }
//     console.log(this.classList);
//   });
// }

// copy to clipboard
// document.querySelector('#copyCodeToClipboard').addEventListener('click', function(e) {
//   e.preventDefault();
//   navigator.clipboard.writeText(this.getAttribute('data-clipboard-text'));
//   document.querySelector('#copyCodeToClipboard .tooltiptext').style.visibility = "visible";
//   setTimeout(function() {
//    document.querySelector('#copyCodeToClipboard .tooltiptext').style.visibility = "hidden";
//   }, 1000);
// }, false);

// /////////////////////////////////////////////////////
// NEW PRODUCT CARD 2024
// /////////////////////////////////////////////////////
if (window.innerWidth < 1000) {
  if (ShopifyAnalytics.meta.page.pageType == 'product') {
    if (document.querySelector('#custom-mobile-box-location'))
      document.querySelector('#custom-mobile-box-location').append(document.querySelector('#custom-price-and-buy-btn-box'));

    let div = document.createElement('div');
    div.id = 'custom-mobile-product-title';

    document.querySelector('product-gallery.product-gallery').parentNode.insertBefore(div, document.querySelector('product-gallery.product-gallery'));
    let divEl = document.querySelector('#custom-mobile-product-title');

    divEl.prepend(document.querySelector('h1.product-info__title'));
    let vendor = document.querySelector('div.product-info__vendor');
    if (vendor)
      divEl.prepend();
    if (document.querySelector('#shopify-block-AK3E4cjBEazNFSFdJb__adcbda8b-e775-4d6b-addc-d1baaf58ef25') != null) {
      divEl.append(document.querySelector('#shopify-block-AK3E4cjBEazNFSFdJb__adcbda8b-e775-4d6b-addc-d1baaf58ef25'));
    }
    divEl.append(document.querySelector('.product-info__badge-list'));
    
    document.querySelector('h1.product-info__title').classList.remove('h5');
    document.querySelector('h1.product-info__title').classList.add('h4');

    if (document.querySelector('#custom-buy-features-box'))
      document.querySelector('.product-info .split-product-info div').prepend(document.querySelector('#custom-buy-features-box'));

    // document.querySelector('#custom-vendor-logo').after(document.querySelector('variant-sku.product-info__sku'));
    document.querySelector('#custom-vendor-logo').after(document.querySelector('#custom-ean-product-box')); 
    document.querySelector('#custom-product-box-rrso').after(document.querySelector('.product-info__inventory'));

    if (document.querySelector('div.product-info__variant-picker') != null) {
      document.querySelector('.product-info__inventory').after(document.querySelector('div.product-info__variant-picker'));
    }

    if (document.querySelector('div.product-info__product-picker') != null) {
      document.querySelector('.product-info__inventory').after(document.querySelector('div.product-info__product-picker'));
    }
    
    

    div = document.createElement('div');
    div.id = 'custom-quantity-and-raty-alior';

    document.querySelector('div.product-info__buy-buttons').parentNode.insertBefore(div, document.querySelector('div.product-info__buy-buttons'));
    divEl = document.querySelector('#custom-quantity-and-raty-alior');
    divEl.prepend(document.querySelector('div.product-info__quantity-selector').nextSibling);
    divEl.prepend(document.querySelector('div.product-info__quantity-selector'));
    // document.querySelector('product-gallery.product-gallery').parentNode.insertBefore(document.querySelector('h1.product-info__title'), document.querySelector('product-gallery.product-gallery'));
    // document.querySelector('h1.product-info__title').parentNode.insertBefore(document.querySelector('div.product-info__vendor'), document.querySelector('h1.product-info__title'));
  }
}

// /////////////////////////////////////////////////////
// MOVE HOME DESCRIPTION AFTER NEWSLETTER
// /////////////////////////////////////////////////////
if (ShopifyAnalytics.meta.page.pageType == 'home') {
  const homeDesc = document.querySelector('#shopify-section-template--18899371917591__custom_html_LEaX3d');
  const homeNewsletter = document.querySelector('#shopify-section-sections--18899372310807__a5a32fb3-1def-418a-9594-33c285c5cbe3');
  if (homeDesc && homeNewsletter) {
    homeNewsletter.after(homeDesc);
  }
}

// /////////////////////////////////////////////////////
// HIDE BUY BUTTON WHEN NOTIFY BTN IS VISIBLE
// /////////////////////////////////////////////////////
if (ShopifyAnalytics.meta.page.pageType == 'product') {
  if (document.querySelector('meta[property="og:availability"]').getAttribute('content') == 'outofstock') {
    document.querySelector('.product-info__buy-buttons button').style.display = 'none';
  }
}

// /////////////////////////////////////////////////////
// CHANGER BUTTON TEXT TO PREORDER
// /////////////////////////////////////////////////////
// if (ShopifyAnalytics.meta.page.pageType == 'product') {
//   const preorderProducts = [15736542593401, 15736543412601, 15736543740281, 15736564875641, 15736575328633, 15736582177145, 15736609079673, 15736616747385 , 15736624906617];
//   if (preorderProducts.includes(ShopifyAnalytics.meta.product.id)) {
//     document.querySelector(".product-info__buy-buttons button div").innerText = 'Zamów w przedsprzedaży';
//     // document.querySelector('.product-info__buy-buttons button').style="background: rgba(248, 58, 58, 0.99);color: white;";
//     document.querySelector('.product-info__inventory').style.display = 'none';
//   }
// }

// /////////////////////////////////////////////////////
// PREORDER ON QUICK DRAWER NAD CART
// /////////////////////////////////////////////////////
(function () {
    const presaleProductIds = [
      15736542593401,
      15736543412601,
      15736543740281,
      15736564875641,
      15736575328633,
      15736582177145,
      15736609079673,
      15736616747385,
      15736624906617,
      15736628445561,
      15736634147193,
      15736652595577,
      15736668881273,
      15736670290297,
      15736674648441,
      15736679825785,
      15736691589497,
      15736692769145,
      15736710103417,
      15736714527097,
      15736714527097,
      15736717279609,
      15736727241081,
      15736740774265
    ];
    const presaleTooltipText = 'Produkt zostanie wysłany po 08.09.2026';

    let debounceTimer = null;

    async function getCartVariantToProductMap() {
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            const map = {};
            cart.items.forEach(item => {
                map[item.variant_id] = item.product_id;
            });
            return map;
        } catch (e) {
            console.error('Presale badge: nie udało się pobrać /cart.js', e);
            return {};
        }
    }

    function getVariantIdFromLineItem(lineItem) {
        const qtyInput = lineItem.querySelector('[data-line-key]');
        if (qtyInput) {
            const lineKey = qtyInput.getAttribute('data-line-key');
            const variantId = parseInt(lineKey.split(':')[0], 10);
            if (!isNaN(variantId)) return variantId;
        }
        const link = lineItem.querySelector('a[href*="variant="]');
        if (link) {
            const url = new URL(link.href, window.location.origin);
            const variantId = parseInt(url.searchParams.get('variant'), 10);
            if (!isNaN(variantId)) return variantId;
        }
        return null;
    }

    function createPresaleBadge() {
        const wrapper = document.createElement('div');
        wrapper.className = 'presale-badge-wrapper';
        wrapper.innerHTML =
            '<span class="presale-badge">' +
                'Przedsprzedaż' +
                '<span class="presale-tooltip-trigger" tabindex="0" role="button" aria-label="Informacja o wysyłce">?</span>' +
                '<span class="presale-tooltip" role="tooltip">' + presaleTooltipText + '</span>' +
            '</span>';
        return wrapper;
    }

    async function injectPresaleBadges() {
        const productMap = await getCartVariantToProductMap();
        const lineItems = document.querySelectorAll('line-item.line-item');

        lineItems.forEach(lineItem => {
            if (lineItem.querySelector('.presale-badge-wrapper')) return;

            const variantId = getVariantIdFromLineItem(lineItem);
            if (!variantId) return;

            const productId = productMap[variantId];
            if (productId && presaleProductIds.includes(productId)) {
                const infoBlock = lineItem.querySelector('.line-item__info .v-stack');
                if (infoBlock) {
                    infoBlock.appendChild(createPresaleBadge());
                }
            }
        });
    }

    // function scheduleInject() {
    //     clearTimeout(debounceTimer);
    //     debounceTimer = setTimeout(injectPresaleBadges, 150);
    // }

    // document.addEventListener('DOMContentLoaded', scheduleInject);

    // // Reaguj na przeładowanie zawartości koszyka (drawer i, docelowo, pełna strona koszyka)
    // const observer = new MutationObserver(scheduleInject);
    // observer.observe(document.body, { childList: true, subtree: true });

    // // Dodatkowe eventy, jeśli motyw je emituje przy add-to-cart / update
    // document.addEventListener('cart:updated', scheduleInject);
    // document.addEventListener('cart:refresh', scheduleInject);
})();

// /////////////////////////////////////////////////////
// SOCIAL ICONS IN FOOTER
// /////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
  const prose = document.querySelector('.footer__block--text .prose');
  if (!prose) return;

  prose.insertAdjacentHTML('afterend', `
    <div class="footer-social-icons" style="display: flex; gap: 12px; margin-top: 12px;">
      <a href="https://www.facebook.com/people/movemorepl/100091654196299/" target="_blank" rel="noopener">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
        </svg>
      </a>
      <a href="https://www.instagram.com/movemore.pl/" target="_blank" rel="noopener">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
          <circle cx="12" cy="12" r="4"/>
          <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
        </svg>
      </a>
    </div>
  `);
});

document.addEventListener('click', function(e) {
  const btn = e.target.closest('button');
  if (!btn) return;

  if (btn.id === 'pc-welcome-btn') {
    console.log('[LOG] WELCOME CLICK');
    window.Shopify.analytics.publish('assistant_start', { button_id: btn.id });
  }

  if (btn.id === 'pc-show-results-btn') {
    console.log('[LOG] SHOW RESULT CLICK');
    window.Shopify.analytics.publish('assistant_result_basic', { button_id: btn.id });
  }

  if (btn.id === 'pc-next-btn' && btn.textContent.trim() === 'Zobacz wyniki') {
    console.log('[LOG] RESULTS EXTENDED CLICK');
    window.Shopify.analytics.publish('assistant_result_extended', { button_id: btn.id });
  }
});

function bindCompareButtons() {
  document.querySelectorAll('.add-to-compare-btn:not([data-compare-tracked])').forEach(btn => {
    btn.setAttribute('data-compare-tracked', 'true');
    btn.addEventListener('click', function() {
      console.log('[LOG] COMPARE CLICK', this.dataset.productHandle, this.dataset.productTitle);
      window.Shopify.analytics.publish('product_compare', {
        product_handle: this.dataset.productHandle,
        product_title: this.dataset.productTitle
      });
    });
  });
}

// Bind na już istniejące
bindCompareButtons();

// Bind na dynamicznie doładowane
const compareObserver = new MutationObserver(bindCompareButtons);
compareObserver.observe(document.body, { childList: true, subtree: true });


// /////////////////////////////////////////////////////
// BUY NOW WE DELIVER THE SAME DAY
// /////////////////////////////////////////////////////

// Lista ID produktów w przedsprzedaży — podmienimy na Twoją listę
const presaleProductIds = [
  15736542593401,
  15736543412601,
  15736543740281,
  15736564875641,
  15736575328633,
  15736582177145,
  15736609079673,
  15736616747385,
  15736624906617,
  15736628445561,
  15736634147193,
  15736652595577,
  15736668881273,
  15736670290297,
  15736674648441,
  15736679825785,
  15736691589497,
  15736692769145,
  15736710103417,
  15736714527097,
  15736714527097,
  15736717279609,
  15736727241081,
  15736740774265
];
const presaleDateLabel = '8.09.2026';

// Polish holidays from September 2025 to December 2027
const holidays = [
    '2025-11-01', '2025-11-11', '2025-12-25', '2025-12-26',
    '2026-01-01', '2026-01-06', '2026-01-29', '2026-01-30', '2026-04-05', '2026-04-06', '2026-05-01',
    '2026-05-03', '2026-05-24', '2026-06-04', '2026-08-15', '2026-11-01',
    '2026-11-11', '2026-12-25', '2026-12-26',
    '2027-01-01', '2027-01-06', '2027-03-28', '2027-03-29', '2027-05-01',
    '2027-05-03', '2027-05-16', '2027-05-27', '2027-08-15', '2027-11-01',
    '2027-11-11', '2027-12-25', '2027-12-26'
];

function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
}

function isHoliday(date) {
    const dateString = date.toISOString().split('T')[0];
    return holidays.includes(dateString);
}

function isWorkingDay(date) {
    return !isWeekend(date) && !isHoliday(date);
}

function getNextWorkingDay(date) {
    const nextDay = new Date(date);

    // TEMPORARY FIX:
    const nextDate = new Date(date);
    nextDate.setHours(0, 0, 0, 0);
    const jan27 = new Date('2026-01-27T00:00:00');
    const jan28 = new Date('2026-01-28T00:00:00');
    const cutoffHour = (nextDate.getTime() === jan28.getTime() || nextDate.getTime() === jan27.getTime()) ? 10 : 11;
    // END TMP FIX

    nextDay.setDate(nextDay.getDate() + 1);
    nextDay.setHours(cutoffHour, 0, 0, 0);

    while (!isWorkingDay(nextDay)) {
        nextDay.setDate(nextDay.getDate() + 1);
    }

    return nextDay;
}

function getPolishDayName(date) {
    const days = ['niedzielę', 'poniedziałek', 'wtorek', 'środę', 'czwartek', 'piątek', 'sobotę'];
    return days[date.getDay()];
}

function formatShippingMessage(nextWorkingDay, now) {
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    const nextWorkingDayStart = new Date(nextWorkingDay);
    nextWorkingDayStart.setHours(0, 0, 0, 0);

    if (nextWorkingDayStart.getTime() === tomorrow.getTime()) {
        return 'Wyślemy już jutro';
    }

    const dayName = getPolishDayName(nextWorkingDay);
    return `Wyślemy w ${dayName}`;
}

function createCountdownTimer() {
    const container = document.createElement('div');
    container.className = 'countdown-container';

    const mainText = document.createElement('div');
    mainText.className = 'countdown-main-text';
    mainText.innerHTML = 'Zamów w ciągu <span class="countdown-timer" id="countdown">--:--:--</span>';

    const orderText = document.createElement('div');
    orderText.className = 'countdown-order-text';
    orderText.textContent = 'Wyślemy jeszcze dziś';

    container.appendChild(mainText);
    container.appendChild(orderText);

    const gallery = document.querySelector('.product-gallery__thumbnail-list-wrapper');
    gallery.parentNode.insertBefore(container, gallery.nextSibling);

    return { mainText, orderText };
}

// Nowa funkcja: statyczny komunikat dla produktów w przedsprzedaży
function createPresaleMessage() {
    const container = document.createElement('div');
    container.className = 'countdown-container presale-container';

    const mainText = document.createElement('div');
    mainText.className = 'countdown-main-text presale-main-text';
    mainText.textContent = `Zamówienia będą realizowane od ${presaleDateLabel}`;

    container.appendChild(mainText);

    const gallery = document.querySelector('.product-gallery__thumbnail-list-wrapper');
    gallery.parentNode.insertBefore(container, gallery.nextSibling);
}

function updateCountdown(mainText, orderText) {
    const now = new Date();

    // TEMPORARY FIX: Remove counter from 09.06.2026 12:00 AM until 15.06.2026
    const jan28_10am = new Date('2026-06-18T10:00:00');
    const feb2 = new Date('2026-06-22T12:00:00');

    if (now >= jan28_10am && now < feb2) {
        mainText.innerHTML = '';
        orderText.textContent = '';
        return;
    }

    // TEMPORARY FIX: For 28.01.2026, use 10:00 AM cutoff instead of 11:00 AM
    const currentDate = new Date(now);
    currentDate.setHours(0, 0, 0, 0);
    const jan27 = new Date('2026-01-27T00:00:00');
    const jan28 = new Date('2026-01-28T00:00:00');
    const cutoffHour = (currentDate.getTime() === jan28.getTime() || currentDate.getTime() === jan27.getTime()) ? 10 : 11;
    // END TMP FIX

    if (isWorkingDay(now) && now.getHours() < cutoffHour) {
        mainText.innerHTML = 'Zamów w ciągu <span class="countdown-timer" id="countdown"></span>';
        orderText.textContent = 'Wyślemy jeszcze dziś';

        const target = new Date();
        target.setHours(cutoffHour, 0, 0, 0);

        const diff = target - now;

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        const timeString =
            String(hours).padStart(2, '0') + ':' +
            String(minutes).padStart(2, '0') + ':' +
            String(seconds).padStart(2, '0');

        document.getElementById('countdown').textContent = timeString;
    } else {
        mainText.innerHTML = 'Zamów w ciągu <span class="countdown-timer" id="countdown"></span>';

        const nextWorking = getNextWorkingDay(now);
        orderText.textContent = formatShippingMessage(nextWorking, now);

        const diff = nextWorking - now;

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        const timeString =
            String(hours).padStart(2, '0') + ':' +
            String(minutes).padStart(2, '0') + ':' +
            String(seconds).padStart(2, '0');

        document.getElementById('countdown').textContent = timeString;
    }
}

// Initialize
if (ShopifyAnalytics.meta.page.pageType == 'product') {
    const currentProductId = ShopifyAnalytics.meta.product.id;

    // if (presaleProductIds.includes(currentProductId)) {
        // Produkt w przedsprzedaży — pokazujemy statyczny komunikat, bez zegarka
        // createPresaleMessage();
    // } else {
        // Standardowe zachowanie z odliczaniem
        const { mainText, orderText } = createCountdownTimer();
        updateCountdown(mainText, orderText);
        setInterval(() => updateCountdown(mainText, orderText), 1000);
    // }
}
// /////////////////////////////////////////////////////
// 2 YEARS WARRANTY PRODUCT CARD
// /////////////////////////////////////////////////////
// document.addEventListener('DOMContentLoaded', function() {
//     // Your hidden badge (place this anywhere in your theme)
//     // <div id="warrantyBadgeSource" style="display: none;">
//     //     <img src="{{ 'warranty-badge.png' | asset_url }}" alt="Warranty">
//     // </div>
    
//     const badgeHTML = document.getElementById('warrantyBadgeSource').innerHTML;
//     const gallery = document.querySelector('.product-gallery__media-list');
    
//     if (gallery) {
//         const images = gallery.querySelectorAll('.product-gallery__media');
//         images.forEach(img => {
//             const badge = document.createElement('div');
//             badge.className = 'warranty-badge';
//             badge.innerHTML = badgeHTML;
//             img.appendChild(badge);
//         });
//     }
// });


document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.vtl-ub-bg-main-widget') != null) {
        document.querySelector('#shopify-block-ANDZxcG1VeDFBcUVxR__vitals_ub_product_bundles_iHtmCV #bundle-product-bundles').after(document.querySelector('.vtl-ub-bg-main-widget'));
    }
});

function waitForElement(selector) {
  return new Promise(resolve => {
    // If it already exists, resolve immediately
    const existing = document.querySelector(selector);
    if (existing) {
      return resolve(existing);
    }

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        resolve(el);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// usage:
waitForElement('.vtl-ub-bg-main-widget').then(el => {
  const newParent = document.querySelector('#shopify-block-ANDZxcG1VeDFBcUVxR__vitals_ub_product_bundles_iHtmCV');
  newParent.appendChild(el); // moves the element
});


// ===================================================================================================================
// ===================================================================================================================
// ============================================= Terms acceptance (cart) ==============================================
// ===================================================================================================================
// ===================================================================================================================
// Works with snippets/terms-acceptance.liquid. The checkbox is "required", so the browser blocks a plain checkout
// submit by itself. Apps (e.g. the cart upsell popup) may catch the checkout click and redirect to /checkout on their
// own, skipping the form, so we also stop that click before any app sees it and save the acceptance as a cart
// attribute via the Ajax API (the form submit alone would not reach the order then). Every copy of the checkbox
// (cart page, cart drawer, "added to cart" popup) keeps the same state, also after the theme re-renders the drawer.

// (() => {
//   const INPUT = '[data-terms-acceptance-input]';
//   const CHECKOUT_TRIGGER = '[name="checkout"], a[href*="/checkout"], form[action*="/checkout"] [type="submit"]';
//   const ATTRIBUTE = 'Akceptacja regulaminu';
//   const STORAGE_KEY = 'termsAccepted';

//   const remembered = () => {
//     try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
//   };
//   const remember = (value) => {
//     try { value ? sessionStorage.setItem(STORAGE_KEY, '1') : sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
//   };

//   // An empty value removes the attribute from the cart.
//   const saveAttribute = (accepted) => fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ attributes: { [ATTRIBUTE]: accepted ? 'Tak' : '' } }),
//   }).catch(() => {});

//   const showError = (input, visible) => {
//     const error = input.closest('[data-terms-acceptance]')?.querySelector('[data-terms-acceptance-error]');
//     if (error) error.hidden = !visible;
//   };

//   const point = (input) => {
//     showError(input, true);
//     input.scrollIntoView({ block: 'center', behavior: 'smooth' });
//     input.focus({ preventScroll: true });
//   };

//   const restore = (root) => {
//     if (!remembered()) return;
//     root.querySelectorAll?.(INPUT).forEach((input) => { input.checked = true; });
//   };

//   // Checkbox for a checkout trigger: the one in its own form, otherwise the first visible one on the page.
//   const checkboxFor = (trigger) => {
//     const own = (trigger.form || trigger.closest('form'))?.querySelector(INPUT);
//     if (own) return own;
//     const all = [...document.querySelectorAll(INPUT)];
//     return all.find((input) => input.offsetParent !== null) || all[0] || null;
//   };

//   // Window + capture phase runs before listeners of the theme and of apps (document / element level).
//   window.addEventListener('click', (event) => {
//     const trigger = event.target.closest?.(CHECKOUT_TRIGGER);
//     if (!trigger) return;
//     const input = checkboxFor(trigger);
//     if (!input || input.checked) return;
//     event.preventDefault();
//     event.stopImmediatePropagation();
//     point(input);
//   }, true);

//   // Plain checkout submit without acceptance: our message instead of the browser bubble.
//   document.addEventListener('invalid', (event) => {
//     const input = event.target;
//     if (!input.matches?.(INPUT)) return;
//     event.preventDefault();
//     point(input);
//   }, true);

//   document.addEventListener('change', (event) => {
//     const input = event.target;
//     if (!input.matches?.(INPUT)) return;
//     remember(input.checked);
//     saveAttribute(input.checked);
//     document.querySelectorAll(INPUT).forEach((other) => {
//       other.checked = input.checked;
//       if (input.checked) showError(other, false);
//     });
//   });

//   // The theme replaces the drawer / popup HTML (section rendering), so new checkboxes need the saved state.
//   restore(document);
//   new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
//       if (node.nodeType === 1) restore(node.matches(INPUT) ? node.parentNode : node);
//     }));
//   }).observe(document.body, { childList: true, subtree: true });
// })();
